    import axiosAuth from '../../../shared/configs/axios-auth'
    
    const getDefaultState = () => {
        return {
            inHouseOrders: null,
            inHouseOrderState: null,
        }
    }
    
    const state = getDefaultState()

    const getters = {
        inHouseOrders: state => {
            return state.inHouseOrders
        },
        inHouseOrderState: state => {
            return state.inHouseOrderState
        },
    }

    const mutations = {
        resetState (state) {
            Object.assign(state, getDefaultState())
        },
        inHouseOrders: (state, payload) => {
            state.inHouseOrders = payload
        },
        inHouseOrderState: (state, payload) => {
            state.inHouseOrderState = payload
        },
    }

    const actions = {
       
        getInHouseOrders: ({commit}, payload) =>{
            commit('updating', true)
            axiosAuth.get('/inHouseOrders/' + payload._id)
            .then(
                res => {
                    commit('updating', false)
                    if(!res.data.message){
                        commit('inHouseOrders', res.data)
                    }
                }
              )
              .catch(
                error => {
                  console.log(error.response)
                  commit('updating', false)

                }
              )
        },

        postInHouseOrder ({commit}, payload) {
            commit('updating', true)
            commit('inHouseOrderState', null)
            axiosAuth.post('/inHouseOrders/'+payload.visitor_group._id, payload)
                .then(
                    res => {
                        console.log(res)
                        commit('inHouseOrderState', res.data)
                        commit('updating', false)
                    }
                )
                .catch(
                error => {
                    console.log(error.response)
                    commit('updating', false)
                }
            )
        },

    }

    export default {
        state,
        getters,
        mutations,
        actions
    }